import 'css-chunksrc/client/scenes/listDuplication/listsList/list/task/nameEditionForm/styles.scss';export default {
  "nameEditionForm": "_nameEditionForm_cdb9m_1",
  "form": "_form_cdb9m_6",
  "name": "_name_cdb9m_1",
  "icon": "_icon_cdb9m_26",
  "input": "_input_cdb9m_30",
  "late": "_late_cdb9m_51",
  "completed": "_completed_cdb9m_58",
  "edition": "_edition_cdb9m_65"
};